/* tslint:disable */
var TMinMax = (function () {

    function createMinMaxForSingleSlipMode(mode, selection) {
        if (!__isFeatureApplicable() || !(mode instanceof SingleSPSlipMode)) return '';

        return __getMinMax(mode, selection);
    }

    function createMinForComboSlipMode(mode, selections) {
        if (!__isFeatureApplicable() || !(mode instanceof ComboSPSlipMode || mode instanceof ComboNoCombinationSPSlipMode)) return '';

        return __getMin(mode, selections);
    }

    function __getMinMax(mode, selection) {
        var min = selection.minBet,
            max = selection.maxBet;

        if (selection.maxBet) {
            return `<div class="min-max_bet" data-uat="min-max-bet">${$dict.bs("Min")} - ${$dict.bs("Max")}: ${formatNumberIfAsian(__roundMinBet(min))} - ${formatNumberIfAsian(__roundMaxBet(max))}</div>`;
        }
        else {
            return `<div class="min-max_bet" data-uat="min-max-bet">${$dict.bs("Min")}: ${formatNumberIfAsian(__roundMinBet(min))}</div>`;
        }
    }

    function __getMin(mode, selections) {
        var min = mode.getComboMinBet(selections);
        return `<div class="min-max_bet" data-uat="min-max-bet">${$dict.bs("Min")}: ${formatNumberIfAsian(__roundMinBet(min))}</div>`;
    }

    function formatNumberIfAsian(value) {
        var isAsianView = typeof (currentBettingViewID) !== 'undefined' && currentBettingViewID === 2;

        return isAsianView
            ? value.toString().toLocalizedNumberString(BetSlip.NumberLocale)
            : value;
    }

    function __isFeatureApplicable() {
        if (!BetSlip.EnableAsianStyleMinMax || !BetSlip.isAsianMode || UserInfo.current === null) return false;

        return true;
    }

    function __roundMinBet(value) {
        if (isNaN(value)) throw 'the type of parameter is not a number, it is: ' + (typeof value);
        var roundNumber = BetSlip.StakeRounding === BetSlip.StakeRoundingMethods.ZeroDecimalPoints ? 0 : 2;

        return (Math.ceil(parseFloat(value) * Math.pow(10, roundNumber)) / (Math.pow(10, roundNumber))).toFixed(roundNumber);
    }

    function __roundMaxBet(value) {
        if (isNaN(value)) throw 'the type of parameter is not a number, it is: ' + (typeof value);
        var roundNumber = BetSlip.StakeRounding === BetSlip.StakeRoundingMethods.ZeroDecimalPoints ? 0 : 2;

        return parseFloat(value).toFixed(roundNumber);
    }

    return {
        createMinMaxForSingleSlipMode: createMinMaxForSingleSlipMode,
        createMinForComboSlipMode: createMinForComboSlipMode
    };
}())

window.TMinMax = TMinMax;